export enum HouseDivisionType {
  INDIVIDUAL = 'INDIVIDUAL',
  DINING_ROOM = 'DINING_ROOM',
  LIVING_AREA = 'LIVING_AREA',
  DINING_SUBROOM = 'DINING_SUBROOM',
  STATION = 'STATION',
  CORRIDOR = 'CORRIDOR',
  ROOM = 'ROOM',
  BED = 'BED',
}
